import { z } from "zod";
import { tokenAliasOrValue } from "./base";
import { DimensionUnit } from "./dimension";

export const SizeUnit = z.enum(["Pixels", "Rem", "Percent"]);

export const SizeValue = z.object({
  unit: DimensionUnit,
  measure: z.number(),
});

export const SizeTokenData = tokenAliasOrValue(SizeValue);

export type SizeUnit = z.infer<typeof SizeUnit>;
export type SizeValue = z.infer<typeof SizeValue>;
export type SizeTokenData = z.infer<typeof SizeTokenData>;
